$(document).on("click", ".new-product-content-btn", function() {
  let value=$(this).data("value")
  if($(this).hasClass("active")){
    $(this).find("span").html("Learn More")
}else{
  $(this).find("span").html("Learn Less") 
}
let className;

if ($(window).width() < 850) {
  if ($(this).parent().find(".new-product-show-more-content.common-pc--hide").length) {
    className = ".new-product-show-more-content.common-pc--hide";
  } else {
    className = ".new-product-show-more-content";
  }
} else {
  if ($(this).parent().find(".new-product-show-more-content.common-small--hide").length) {
    className = ".new-product-show-more-content.common-small--hide";
  } else {
    className = ".new-product-show-more-content";
  }
}
  $(this).toggleClass("active").parents(".common-section-container").find(className).slideToggle('slow',function(){
    if ($(this).is(':visible')){
      if($(window).width()<850 &&  value=="flex" ){
        $(this).css('display','flex')
      }else{
        $(this).css('display','grid')
      }
      
    }
  })
});